export type RegionAssetFields = {
  region_background?: string;
  default_map_marker?: string;
};

function assetValue(raw: string | undefined): string | undefined {
  const v = (raw || '').trim();
  return v && v.toLowerCase() !== 'default' ? v : undefined;
}

/**
 * Region-scoped CDN asset fields for POST/PUT /admin/regions. PUT replaces the whole item,
 * so a set value must be sent on every save; an omitted field clears it.
 */
export function regionAssetPayload(form: RegionAssetFields): RegionAssetFields {
  const out: RegionAssetFields = {};
  const bg = assetValue(form.region_background);
  if (bg) out.region_background = bg;
  const marker = assetValue(form.default_map_marker);
  if (marker) out.default_map_marker = marker;
  return out;
}
